import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

interface PageHeaderProps {
  title: string;
  icon: React.ReactNode;
  action?: React.ReactNode;
  description?: React.ReactNode;
  onBack?: () => void;
  actionAlign?: 'flex-start' | 'center' | 'flex-end';
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, icon, action, description, onBack, actionAlign = 'center' }) => {
  return (
    <Box sx={{ pt: { xs: 1, sm: 0 }, pb: { xs: 1, sm: 1.5 }, pl: 0, pr: { xs: 0, sm: 3 }, mx: { xs: -2, sm: 0 } }}>
      <Box sx={{ display: 'flex', alignItems: actionAlign, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            onClick={onBack ?? (() => window.history.back())}
            sx={{ color: '#3c3c3c', p: 0.5, mr: 1, flexShrink: 0 }}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 22 }} />
          </IconButton>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: '#3c3c3c' }}
          >
            {icon}
            {title}
          </Typography>
        </Box>
        {action && <Box>{action}</Box>}
      </Box>
      {description && (
        <Box sx={{ pt: 1, pl: '38px' }}>
          {description}
        </Box>
      )}
    </Box>
  );
};

export default PageHeader;
